import styled from '@emotion/styled';

import { useDispatch } from 'react-redux';

import Pagination from '../../../shared/components/Pagination/Pagination';
import Button from '../../../shared/components/Button/Button';
import {
  modifyProductInquiryForm,
  setProductInquiryCurrentPage,
} from '../../detail/slice';
import { ProductInquiryPostPagination } from '../types';
import { amplitudeService } from '../../../shared/amplitude';
import {
  SelectAddProductInquiry,
} from '../../../shared/amplitude/events/product/SelectAddProductInquiry';
import { getFusionQueryId } from '../../detail/shared/utils/productDetailEvent';
import { useAppSelector } from '../../../shared/store';

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

const ButtonWrap = styled.div`
  position: absolute;
  right: 0;
  button {
    border-radius: 3px;
  }
  span {
    font-size: 14px;
    font-weight: 500;
  }
`;

interface Props {
  pagination: ProductInquiryPostPagination;
}

export default function BoardTableBottomContainer({ pagination }: Props) {
  const { queryId } = useAppSelector(({ productList }) => productList);

  const { currentPage, totalPages } = pagination;

  const dispatch = useDispatch();

  const handleClickPrev = () => {
    dispatch(setProductInquiryCurrentPage(currentPage - 1));
  };

  const handleClickNext = () => {
    dispatch(setProductInquiryCurrentPage(currentPage + 1));
  };

  const handleClickButton = () => {
    amplitudeService.logEvent(new SelectAddProductInquiry({
      fusionQueryId: getFusionQueryId(queryId),
    }));

    dispatch(modifyProductInquiryForm({
      open: true,
      subject: '',
      content: '',
      isSecret: false,
      mode: 'new',
    }));
  };

  return (
    <Container>
      <Pagination
        previousEnable={currentPage > 1}
        nextEnable={currentPage < totalPages}
        onClickPrevious={handleClickPrev}
        onClickNext={handleClickNext}
      />
      <ButtonWrap>
        <Button
          type="button"
          text="문의하기"
          onClick={handleClickButton}
          width={120}
          height={44}
        />
      </ButtonWrap>
    </Container>
  );
}
